import { render, staticRenderFns } from "./auth-login-page.vue?vue&type=template&id=3481591e"
import script from "./auth-login-page.vue?vue&type=script&lang=js"
export * from "./auth-login-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports